module.exports = __webpack_public_path__ + "static/media/frostbite.b25a8e5a.png";